// images
import img1 from "./images/grocery list.png";
import img2 from "./images/reviews.png";
import img3 from "./images/tip calculator.png";
import img4 from "./images/dice challenge.png";
import img5 from "./images/drum kit.png";
import img6 from "./images/simon game.png";
import img7 from "./images/rating component.png";
import img8 from "./images/advice generator.png";

const data = [
  {
    id: 1,
    title: "Grocery List",
    link: "https://react-project-grocery-list-2022.netlify.app/",
    image: img1,
    category: "React",
    repo: "#",
  },
  {
    id: 2,
    title: "Reviews",
    link: "https://react-project-reviews-2022.netlify.app/",
    image: img2,
    category: "React",
    repo: "#",
  },
  {
    id: 3,
    title: "Tip Calculator",
    link: "https://scrub4life.github.io/tip-calculator/",
    image: img3,
    category: "jQuery",
    repo: "https://github.com/Scrub4Life/tip-calculator/tree/gh-pages",
  },
  {
    id: 4,
    title: "Dice roll",
    link: "https://scrub4life.github.io/dice-game/",
    image: img4,
    category: "jQuery",
    repo: "https://github.com/Scrub4Life/dice-game/tree/gh-pages",
  },
  {
    id: 5,
    title: "Drum kit",
    link: "https://scrub4life.github.io/drum-kit/",
    image: img5,
    category: "jQuery",
    repo: "https://github.com/Scrub4Life/drum-kit/tree/gh-pages",
  },
  {
    id: 6,
    title: "Simon game",
    link: "https://scrub4life.github.io/simon-game/",
    image: img6,
    category: "jQuery",
    repo: "https://github.com/Scrub4Life/simon-game/tree/gh-pages",
  },
  {
    id: 7,
    title: "Rating component",
    link: "https://avery-blake-interactive-rating-component.vercel.app/",
    image: img7,
    category: "React",
    repo: "https://github.com/Scrub4Life/interactive-rating-component",
  },
  {
    id: 8,
    title: "Advice Generator",
    link: "https://avery-blake-advice-generator.vercel.app/",
    image: img8,
    category: "React",
    repo: "https://github.com/Scrub4Life/advice-generator/tree/master",
  },
];

export default data;
